<template lang="pug">
div
  .table-responsive.custom-table
    table.table-history
      thead
        tr
          th {{ $t('ui.date') }} 
          th {{ $t('ui.type') }}
          th {{ $t('ui.amount') }}
      tbody
        template(v-if="transferDetails.length > 0")
          tr(v-for="ticket in transferDetails")
            td {{ $moment(ticket.created_date).format("YYYY-MM-DD HH:mm:ss") }}
            td {{ ticket.request_type }}
            td {{ currencyCode }} {{ $numeral(ticket.amount).format("0,0.00") }}
        template(v-else)
          tr
            td(colspan="3") {{$t('ui.no_record')}}
  .statement-mobile
    .statement-single
      template(v-if="transferDetails.length > 0")
        .statement-single-content(v-for="data in transferDetails")
          .statement-detail
            .statement-detail-left {{data.request_type}}
            .statement-detail-right.text-warning {{data.amount}}
          .statement-detail
            .statement-detail-left {{$t('ui.bonus')}}
            .statement-detail-right {{ data.bonus_amount }}
          .statement-balance
            .statement-balance-left 
            .statement-balance-right {{ $moment(data.created_date).format("YYYY-MM-DD HH:mm:ss") }}
      template(v-else)
        .text-center.py-2 {{ $t('ui.no_record') }}
</template>

<script>
export default {
  computed: {
    transferDetails() {
      return this.$store.getters.transferDetails
    },
    currencyCode() {
      return this.$store.getters.currencyCode
    }
  }
};
</script>
